import LyUseStatus from './src/index.vue'

LyUseStatus.install = function (Vue) {
    Vue.component(LyUseStatus.name, LyUseStatus)
}

export default LyUseStatus



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/use-status/index.js
// module id = null
// module chunks = 